import styled from 'styled-components';
import ResizablePanel from '@shared/components/ResizablePanel';

export const Container = styled.div`
  height: calc(100vh - 26px - 60px);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Header = styled.div`
  font-size: 18px;
  line-height: 32px;
  padding: 16px;
  background-color: #fff;
`;

export const Content = styled(ResizablePanel)`
  flex: 1;
  height: 1px;
`;

export const ManagementContent = styled.div`
  padding: 16px;
  flex: 1;
  box-sizing: border-box;
  background-color: #fff;
`;

export const TableCount = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
